export const SET_ROOM_CHARGE_ORDER_ID = 'SET_ROOM_CHARGE_ORDER_ID'
export const SET_ROOM_CHARGE_GUESTS = 'SET_ROOM_CHARGE_GUESTS'
export const SET_ROOM_CHARGE_GUESTS_ARE_LOADING = 'SET_ROOM_CHARGE_GUESTS_ARE_LOADING'
export const SET_ROOM_CHARGE_IS_PROCESSING = 'SET_ROOM_CHARGE_IS_PROCESSING'
export const SET_ROOM_CHARGE_ERROR_CODE = 'SET_ROOM_CHARGE_ERROR_CODE'
